module.exports = __webpack_public_path__ + "img/line-chart-stepped-dark-01.40e0447b.jpg";